export const POST_TAGS_MODAL = "POST_TAGS_MODAL";
export const POST_LOCATION_MODAL = "POST_LOCATION_MODAL";
